module.exports = __webpack_public_path__ + "static/wp1-2-ea6ab749e344ee458cc7abd9d6ad52c7.jpg";